import { useEffect, useContext } from 'react'
import axios from 'axios'

import Loader from './components/Loader'
import AppRoute from './containers/AppRoute'
import { apiLink } from './env'
import PlansContext from './context/Plans'

import './App.scss'

// bootstrap doesnt work without this line AFTER App.scss
import bootstrap from 'bootstrap'


function App() {

    const { plans, setPlans } = useContext(PlansContext)

    const fetchPlans = async () => {

        try {
            const res = await axios.get(`${apiLink}/zs/checkout/fetch_stripe_plans`)
            setPlans(res.data) 
        }
        catch (err) {
            console.log({err})
        }

    }

    const handleAppLoad = async () => await fetchPlans()

    useEffect(() => handleAppLoad(), [])

    return (
        <>
            {plans && <AppRoute />}
            {!plans && <Loader />}
        </>
    )

}

export default App
